<template>
  <v-dialog v-model="show" persistent width="450">
    <v-card>
      <v-card-title>
        <v-icon class="mr-2" :color="titleIconColor">
          mdi-{{ titleIcon }}
        </v-icon>
        <span class="title-text">
          {{ $t('queues.pauseDlg.' + title) }}
        </span>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text>
        <div class="pt-3">
          <div v-for="(agent, idx) in agents" :key="idx">
            <status-avatar class="agent-avatar mr-4" :user="avatarUser(agent.exten)" avatar-size="22px" badge-size="7px"/>
            <span class="agent-text subtitle-1 ml-2">
              {{ agent.name }} <small>x{{ agent.exten }}</small>
            </span>
          </div>
        </div>
        <div>
          <v-switch v-model="enableCause"
            :label="$t('queues.pauseDlg.enableCause')">
          </v-switch>
        </div>
        <v-autocomplete
          v-model="causeCode"
          v-show="enableCause"
          :loading="loading"
          :items="causes"
          item-text="text"
          item-value="value"
          :messages="hint"
          :search-input.sync="search"
          :label="$t('queues.pauseDlg.label')"
          outlined
          hide-no-data
          clearable>
          <template v-slot:append-outer>
            <cp-help i18n="queues.pauseCause" />
          </template>
        </v-autocomplete>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="cancel" text>
          {{ $t('queues.pauseDlg.cancel') }}
        </v-btn>
        <v-btn :disabled="enableCause && !causeCode"
          @click="confirm" :color="titleIconColor" text class="btn-confirm">
          {{ $t('queues.pauseDlg.' + title) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api'
import { mapGetters } from 'vuex'
import events from 'Store/events'
import StatusAvatar from '@/components/buddies/status_avatar'

export default {
  name: 'agent-pause-confirm',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    titleIcon: {
      type: String,
      required: true
    },
    titleIconColor: {
      type: String,
      required: true
    },
    agents: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      enableCause: false,
      loading: false,
      causes: [],
      hint: '',
      causeCode: null,
      causeCodeFormatted: null,
      search: null
    }
  },
  components: { StatusAvatar },
  computed: {
    ...mapGetters({
      canSelfPause: 'permissions/canQSelfPause',
      canAgentPause: 'permissions/canQAgentPause',
      users: 'users/listAll',
      buddies: 'users/buddies'
    })
  },
  watch: {
    enableCause: function (val) {
      if (!val) {
        this.resetCauses()
        return
      }
      this.fillPauseCodesList()
    },
    search: function () {
      this.fillPauseCodesList()
    }
  },
  methods: {
    fillPauseCodesList: function () {
      this.loading = true

      API.getMemberPauseCodes({ search: this.causeCode }).then(resp => {
        resp.data.data.forEach(c => {
          this.causes.push({
            text: this.getFormattedPauseCode(c.pause_code_raw),
            value: c.pause_code_raw
          })
        })
        if (this.causeCode) {
          this.causeCodeFormatted = this.causes[0].text
        }
        this.hint = resp.data.total > 0 && this.causeCode === null
          ? `${this.$t('queues.pauseDlg.hint')}: ${resp.data.total}`
          : ''
      }).catch(err => {
        this.dbg(err)
        this.dbg(err.response)
        const msg = API.getException(err) ||
          'Failed to load pause causes list from API'
        events.pubError(msg)
      }).finally(() => {
        this.loading = false
      })
    },
    resetCauses: function () {
      this.causes.splice(0)
      this.causeCode = null
      this.hint = ''
    },
    cancel: function () {
      this.resetCauses()
      this.enableCause = false
      this.$emit('cancel')
    },
    confirm: function () {
      this.hint = ''
      this.enableCause = false
      this.$emit('set-pause', this.getFormattedPauseCode(this.causeCode))
    },
    getFormattedPauseCode: function (pauseCodeRaw) {
      const defaultCodes = [
        'lunch_break',
        'break',
        'wrap_up_time',
        'clock_out',
        'meeting'
      ]
      if (defaultCodes.includes(pauseCodeRaw)) {
        return this.$t(`queues.pauseDlg.pauseCodes.${pauseCodeRaw}`)
      } else {
        return pauseCodeRaw
      }
    },
    avatarUser (extension) {
      const buddyUser = this.buddies.find((user) => user.exten === extension)
      if (buddyUser) {
        return buddyUser
      }
      return this.users.find((user) => user.exten === extension)
    }
  }
}
</script>

<style scoped>
</style>
